import {gql} from "@apollo/client";

export const FGM_GLOBAL_ALERT_STATE_FIELDS = gql`
  fragment GlobalAlertStateFields on GlobalAlertState {
    id
    created_at
    up_at
    state_has_changed
    state_is_up
    num_locations_down
    service_is_deleted
    service_monitoring_type
    ignored
    service_id
    status
  }
`;
